import { createAction, createReducer } from "@reduxjs/toolkit";
import { TESTCASE_RUN_STATUS } from "../../types/global.enum";

export interface TestCaseRunState {
    requestId: string;
    status: TESTCASE_RUN_STATUS;
    testCaseId: number; // Add testCaseId to the interface
    caseRunId?: number; // Optional, if you want to track a specific case run ID
    runCleared?: boolean;
    runEngine?: string | null;
}

export const setTestCaseRunState = createAction<{projectId: number; testCaseId: number; state: TestCaseRunState}>('setTestCaseRunState');
export const clearTestCaseRunState = createAction<{projectId: number; testCaseId: number}>('clearTestCaseRunState');
export const setTestCaseRunCleared = createAction<{projectId: number; testCaseId: number}>('setTestCaseRunCleared');

export const buildRunKey = (projectId: number, testCaseId: number) => `${projectId}-${testCaseId}`;

export interface RunState {
    [key: string]: TestCaseRunState;

}

export const runReducer = createReducer<RunState>({}, (builder) => {
    builder
        .addCase(setTestCaseRunState, (state, action) => {
            const key = buildRunKey(action.payload.projectId, action.payload.testCaseId);
            console.log('Setting run state for key:', key, 'with state:', action.payload.state , 'state:', state);
            state[key] = {
                ...action.payload.state,
                testCaseId: action.payload.testCaseId, // Include testCaseId in the state
                runCleared: false,
            };
        })
        .addCase(clearTestCaseRunState, (state, action) => {
            const key = buildRunKey(action.payload.projectId, action.payload.testCaseId);
            delete state[key];
        })
        .addCase(setTestCaseRunCleared, (state, action) => {
            const key = buildRunKey(action.payload.projectId, action.payload.testCaseId);
            if (state[key]) {
                state[key].runCleared = true;
            }
        });
});
